export function getNgClassInputAsString(value: NgClassInput): string {
    return typeof value === 'string'
        ? value
        : Array.isArray(value) || value instanceof Set
        ? [...value].join(' ')
        : typeof value === 'object'
        ? Object.keys(value)
              .filter((k) => value[k])
              .join(' ')
        : '';
}

type NgClassInput = string | string[] | { [className: string]: boolean } | Set<string>;
